export class TestCenterDataModel {
    test_center_id: string|null='';
    postal_code?: string|null='';
    id: string|null='';
    test_center_name: string|null='';
    long?: number|null=0;
    lat?: number|null=0;
 
  }
  